var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box-shadow-bottom" }, [
    _c("div", { staticClass: "pane-content" }, [_vm._t("default")], 2),
    _vm._v(" "),
    _c("div", { staticClass: "pane-bottom" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }